import { render, staticRenderFns } from "./TextView.vue?vue&type=template&id=39e4ef82&scoped=true&"
import script from "./TextView.vue?vue&type=script&lang=js&"
export * from "./TextView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4ef82",
  null
  
)

export default component.exports